// One speech owner across flight, library, and reviews. Uses the browser voice.
export function createNarration({ synth = globalThis.speechSynthesis, Utterance = globalThis.SpeechSynthesisUtterance } = {}) {
  let active = null;
  let generation = 0;
  const listeners = new Set();
  const supported = !!synth && !!Utterance;
  let rate = 1;
  let message = supported ? '' : 'このブラウザでは読み上げを利用できません。';
  function notify() { for (const fn of listeners) fn(); }
  function stop() {
    generation++;
    active = null;
    if (supported) synth.cancel();
    notify();
  }
  return {
    supported,
    get activeId() { return active; },
    get message() { return message; },
    setRate(value) { rate = Number(value) || 1; },
    stop,
    speak(id, text) {
      if (!supported) return;
      if (active === id) { stop(); return; }
      stop();
      const token = generation;
      try {
        const utterance = new Utterance(text);
        utterance.lang = 'ja-JP';
        const voice = synth.getVoices().find(v => v.lang.startsWith('ja'));
        if (voice) utterance.voice = voice;
        utterance.rate = rate;
        utterance.onend = () => { if (token === generation) { active = null; notify(); } };
        utterance.onerror = (event) => {
          if (token !== generation) return;
          active = null;
          message = event.error === 'interrupted' || event.error === 'canceled' ? '' : '読み上げを開始できませんでした。端末の日本語音声を確認してください。';
          notify();
        };
        active = id;
        message = '';
        synth.speak(utterance);
        notify();
      } catch {
        active = null;
        message = '読み上げを開始できませんでした。';
        notify();
      }
    },
    subscribe(fn) { listeners.add(fn); return () => listeners.delete(fn); },
  };
}
export const narration = createNarration();
